import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import MoreWinners from './common/MoreWinners';
import withLocation from "../../withLocation";
import withContext from "../../withContext";
const service = new Service();


class MoreWinnersLanding extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        let initialData = [];
        let count;
        let record = "yes";
        var dataAry =[];
        
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData,
            count: 2,
            record : record,
            dataAry: dataAry,
            metaTitle: "Memories Contest",
            metaDescription: [
                { "name": "description", "content": "Memories Contest - FirstCry Parenting" }
            ]
        }

        this.qnaPageNo = 1;
        this.totalCount = this.state.initialData?.length > 0 ? this.state.initialData?.length : '';
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
        // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var ConDetailUrl = reqUrl.split('/')[5] ? reqUrl.split('/')[5] : '';
        
            var url = global.api_url + "contest/getcontestwinnerlist";
            let body = JSON.stringify({ 
                        "pageNo": 1,
                        "pageSize": 10 ,
                        "contestId": reqUrl.split('/')[5]      
                    })
                    // console.log('body 1:', body);
            return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        if(navigator.onLine) {
            console.log('winners init data ',this.state.initialData);
            if(this.state.initialData?.result != 'Record Not Found'){
                // let inData = this.state.initialData.result[0]['winners']; 
                let inData = this.state.initialData?.result?.[0]?.winners || [];
                this.setState({ winnersinitialData: [] });
                this.setState({ winnersinitialData: inData});
            }else{
                this.setState({ winnersinitialData: [] });
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                var cIDtitle = this.props.match.url.split('/');
                var cID = cIDtitle[5] ? cIDtitle[5] : '';
                var dUlr = cIDtitle[3] ? cIDtitle[3] : '';
                var conID = cIDtitle[5] ? cIDtitle[5] : '';
                this.setState({ cTitle: dUlr });
                var title1 = dUlr.replace(/-/g," ");
                title1 = this.capitalizeFirstLetters(title1);
                this.setState({ title1: title1 });
                this.setState({ conID: conID });
                // console.log('length < 1 cID =====> ', cID);
                // this.winnersListAPICall(cID);
            } else {
                localStorage.setItem('moreWinner', JSON.stringify(this.state.initialData));
                service.hideLoader();
            }
        
            if((this.state.initialData && this.state.initialData.result =='Record Not Found') || (this.state.initialData =='Unsuccess')){
                // console.log('****************** Record Not Found *************** ');
                var Contitle = this.props.match.url.split('/');
                var dUlr = Contitle[3] ? Contitle[3] : '';
                var conID = Contitle[5] ? Contitle[5] : '';
                this.setState({ cTitle: dUlr });
                var title1 = dUlr.replace(/-/g," ");
                title1 = this.capitalizeFirstLetters(title1);
                this.setState({ title1: title1 });
                this.setState({ conID: conID }); 
                // this.winnersListAPICall(conID);
            }
            if (this.state.initialData && this.state.initialData.result && this.state.initialData.result.length > 1){
                // window.addEventListener('scroll', this.listenToScroll)
            }
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
        console.log('winnerslanding this.state.initialData', this.state.initialData)
        if(this.state.initialData.result != 'Record Not Found'){
            this.totalCount = this.state.initialData?.result?.[0]?.winners?.length || 0;
            // this.totalCount = this.state.initialData.result[0]['winners'].length;
            console.log(' ---- ', this.totalCount);
            this.pageData = this.pageData.bind(this);
            window.addEventListener("scroll", this.pageData, false);
        }
        // console.log('********************* ',this.state.initialData.result) 
    }

    // pagination code start=====================
    pageData() {
        // debugger;
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            // debugger;
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                    var checkVal = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
                if (!(checkVal) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount >= (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.LoadAllTypesContestOnScroll(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    LoadAllTypesContestOnScroll(pageno, size) {
        // debugger;
        var hostUrl = window.location.pathname; 
        var ConDetailUrl = this.props.match.url.split('/');
        var dUlr = ConDetailUrl[5];
        var url = global.api_ci_url + "MemoriesContest/getcontestwinnerlist";
        // var url = global.api_url + "contest/getcontestwinnerlist";
        var postData = {
            "pageno": pageno,
            "pagesize": size,
            "contestId": dUlr
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == 1) {
                if (this.state.winnersinitialData.length > 0) {
                    if(json['result'].length > 0){
                        this.setState({record : 'yes'})
                    }else{
                        this.setState({record : 'No'})
                    }
                    if (size == (pageno * 10)) {
                        this.setState({ winnersinitialData: json['result']});
                    } else {
                        
                        let ary = this.state.winnersinitialData;
                        this.setState({ winnersinitialData: ary.concat(json['result'][0]['winners'])});
                        this.totalCount = this.state.winnersinitialData.length;
                        console.log('pageno : '+ pageno +' totalCount '+ this.totalCount )
                    }
                }
            }
            service.hideLoader();
            
        }).catch((error) => {
            console.error(error);
        });
    }
    // paginatoin code end ======================

    winnersListAPICall(contestId){
        // console.log('***************************************')
        var postData = {
            "pageno": 1,
            "pagesize": 10 ,
            "contestId": contestId 
        }
        // console.log('postData 2:', postData);
        var url = global.api_ci_url + "MemoriesContest/getcontestwinnerlist";
        // var url = global.api_ci_url + "MemoriesContest/getcontestwinnerlist";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) { 
                this.totalCount = json['result'].length;
                // console.log("inside result winners......")               
                this.setState({ initialData: json });
                // console.log('********************* ',this.state.initialData)
                service.hideLoader();
            }            
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    capitalizeFirstLetters(str){
        return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
            return letter.toUpperCase();
        })
    }

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    {this.state.initialData?.result?.length > 0 && (
                        <>
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href="/baby-photo-contest">Memories Contest</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a className="R11_9e" href={`/baby-photo-contest/contest/${this.state.initialData && this.state.initialData.result && this.state.initialData.result[0].title ? actions.loadcontestName(this.state.initialData.result[0].title) : this.state.cTitle}/${this.state.initialData && this.state.initialData.result[0].contest_id ? this.state.initialData.result[0].contest_id : this.state.conID}`}>{this.state.initialData.result[0].title ? this.state.initialData.result[0].title :this.state.title1}</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span className="R11_9e">All Winners</span>
                    </div>
                    
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>All Winners - {this.state.initialData && this.state.initialData.result[0].title ? this.state.initialData.result[0].title :this.state.title1}</h1>
                    </>
                    )}

                </div>
                <div className="sub-container memoriesContest-cnt left">
                    <div className="data-container left">
                    {this.state.initialData?.result?.length > 0 ?
                        <>
                    {/* start */}
                        <div className="container_bump">
                        <input type="hidden" id="page_no" name="page_no" value={this.state.count}/>
                            <div className="More_winners" id="winnertabsection">
                                {this.state.winnersinitialData && this.state.winnersinitialData.length > 0 ?
                                <div className="winnersmob-cnt" id="winners-list" ref={this.myRef}> 
                                    <div className="allWinners">
                                        <ul className="participant-list">
                                            {this.state.winnersinitialData && this.state.winnersinitialData.length > 0 && this.state.winnersinitialData.map((value, index) =>
                                            <li className="participant" key={value.id}>
                                                <a href={`/memories/photodetails/${value.id}`} className="parti-img" key={value.index}  onClick={() => actions.networkCheck()}>
                                                    <img src={value.image_url ? value.image_url.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp"): value.user_photo.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = value.image_url? value.image_url.replace("http://", "https://") : value.user_photo.replace("http://", "https://"))}/>
                                                    <div className="winnertag">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/contest-winner-icon.svg'} alt="winner" title="winner" />
                                                    </div>
                                                </a>
                                                <div id="winner-nm" className="winner-name M13_42">{value.userName ? value.userName : ''}</div>
                                                <div className="prize-won R13_9e">{value.prize ? value.prize : ''}</div>
                                            </li>
                                            )}
                                        </ul>
                                        {/* <MoreWinners eleRef={this} moreWinnersData={this.state.moreWinnersData} currentPage={this.state.count} record = {this.state.record}/> */}
                                        <MoreWinners eleRef={this} MoreleatherDetails={this.state.winnersinitialData} />
                                        <input type="hidden" id="pgNo" value="" />
                                    </div>
                                </div>
                                : 
                                <div className="submit_first_blog_container">
                                    <div className="icon_container">
                                        <span className="submit_blog_icon" data-icon-font="&#xe035;"></span>
                                    </div>
                                    <div className="submit_data_container">
                                        <span className="R14_42">We are yet to announce winners for our Contest. <br/>Please re-visit this section after some time.</span>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        </>
                        
                        :
                        <div className="container_bump notDeclareScreen">
                            <div className="icon status_icon" data-icon-font="R"></div>
                            Voting and Participation for this contest is over. Do visit this page soon to know Winners of the Contest!

                        </div>
                        }

                    {/* end */}
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(MoreWinnersLanding);
